import React, { useEffect, useState } from 'react';
import { useViewWidth } from '@utils/helpers/viewWidth';

export interface FillHeightContainerProps {
  children: React.ReactNode;
  className?: string;
  key?: string;
  bottomOffset?: number;
  overwriteHeight?: boolean;
}

const FillHeightContainer = (props: FillHeightContainerProps) => {
  const [height, setHeight] = useState(400);
  const viewWidth = useViewWidth();

  function calculateHeight() {
    const element = document.getElementById(
      'fillHeightContainer' + (props.key ?? ''),
    );
    if (!element) {
      return;
    }

    const viewHeight = window.innerHeight;
    const yAxis = element.getBoundingClientRect().y;
    const calculatedHeight = viewHeight - yAxis - (props.bottomOffset ?? 0);

    setHeight(calculatedHeight);
  }

  useEffect(() => {
    calculateHeight();
  }, [viewWidth, props.bottomOffset]);

  return (
    <div
      id={'fillHeightContainer' + (props.key ?? '')}
      className={props.className ?? ''}
      style={{ height: props.overwriteHeight ? 'auto' : height }}
    >
      {props.children}
    </div>
  );
};

export default FillHeightContainer;
